module.exports = __webpack_public_path__ + "fonts/Manrope-400-cyrillic2.765433f.woff2";